const VermutMass=[
    {
        id:1,
        title:"Мартіні Б’янко, Россо, Драй (Італія) 1 л",
        price:"1400 грн",
        src: require('../img/martini.webp'),
        text:"100мл - 140грн",
    },
    
]

export default VermutMass;